<template>
	<div v-if="isShow">
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" :dots="pageSetup.bannerList.length>1?'inside':'none'">
			<CarouselItem v-for="(item,index) in pageSetup.bannerList">
				<div class="banner"
					:style="{'background':'url('+(item.imgPath?item.imgPath:setImg('secondaryPage/funds/banner','jpg'))+') center center no-repeat'}">
					<div>
						<p class="projectTitle">{{item.productName}}</p>
						<p class="banner_projectDes">{{item.describe}}</p>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent" style="margin-bottom: 0;">
			<div>
				<p class="moduleTitle">精选服务</p>
				<div v-if="pageSetup.productList.length==1" class="one_product">
					<div>
						<img
							:src="pageSetup.fundsProduct.imgPath?pageSetup.fundsProduct.imgPath:setImg('secondaryPage/funds/one','jpg')" />
					</div>
					<ul>
						<li v-for="(item,i) in pageSetup.productList" :key="i">
							<p class="name">{{item.reportName}}</p>
							<div v-html="valuationDesHtml(item.reportStage,item.reportType)" style="margin-bottom: 36px;"></div>

							<div class="operate">
								<button @click="productEntrance(item.reportStage,item.reportType)">立即填写</button>
								<a target="_blank" :href="item.reportExample">查看报告示例</a>
							</div>
						</li>
					</ul>
				</div>
				<div v-else-if="pageSetup.productList.length==3">
					<ul class="multipleProducts threeProducts">
						<li v-for="(item,i) in pageSetup.productList" :key="i"
							:style="{'background':'url('+setImg('secondaryPage/funds/three'+(i+1),'jpg')+') center center no-repeat'}">
							<p class="name">{{item.reportName}}</p>
							<div v-html="valuationDesHtml(item.reportStage,item.reportType)"></div>
							<div class="operate">
								<button @click="productEntrance(item.reportStage,item.reportType)">立即填写</button>
								<a target="_blank" :href="item.reportExample">查看报告示例</a>
							</div>
						</li>
					</ul>

				</div>
				<div v-else>
					<ul class="multipleProducts">
						<li v-for="(item,i) in pageSetup.productList" :key="i">
							<img :src="setImg('secondaryPage/funds/two'+(i+1),'jpg')" alt="" />
							<div>
								<p class="name">{{item.reportName}}</p>
								<div v-html="valuationDesHtml(item.reportStage,item.reportType)"></div>
								<div class="operate">
									<button class="buttonFill" @click="productEntrance(item.reportStage,item.reportType)">立即填写</button>
									<a class="buttonBorder" target="_blank" :href="item.reportExample">查看报告示例</a>
								</div>
							</div>
						</li>
					</ul>
				</div>

			</div>

		</div>


		<div>
			<p class="moduleTitle">基金评价介绍</p>
			<div class="evaluationIntroduction"
				:style="{'background':'url('+(pageSetup.introduction.background.imgPath?pageSetup.introduction.background.imgPath:setImg('secondaryPage/funds/introduction','jpg'))+') center center no-repeat'}">

				<div>
					<p>{{pageSetup.introduction.describe}}</p>
				</div>

			</div>
		</div>

		<div>
			<p class="moduleTitle">基金评价优势</p>
			<div class="preponderance">
				<div>
					<img
						:src="pageSetup.advantage.background.imgPath?pageSetup.advantage.background.imgPath:setImg('secondaryPage/funds/advantage','jpg')" />
				</div>
				
				<div>
					<ul>
						<li v-for="(item,i) in pageSetup.advantage.describe.split('|')">{{item}}</li>
					</ul>
					
				</div>
				

			</div>
		</div>



		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header/flow_header.vue'
	import Footer from '@/common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'

	import qs from 'qs'
	import axios from 'axios'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				value: 0,
				pageSetup: {
					groupId: 6,
					bannerList: [{
						imgPath: '',
						isLoading: false,
						englishName: '', // 英文名称
						productName: 'Ai基金', // 产品名称
						subheading: '', // 副标题
						describe: '从基金的募投管退、合作及履约等方面进行科学有效的量化评价，提升管理人基金管理水平；运用七维价值模型，生成专业、全面、客观、公允的智能化基金估值。' // 文字描述
					}],
					fundsProduct: {
						imgPath: '',
						isLoading: false,
						imgLoading: false
					},
					introduction: {
						background: {
							imgPath: '',
							isLoading: false,
							imgLoading: false
						},
						describe: '在近年政府和产业引导基金迅速发展的背景下，如何对其进行规范管理也逐渐成为引导基金管理人工作中的一个重点和难点。心流基金绩效评价系统分别从基金的募资表现、投资表现、管理表现、退出表现和合作表现及履约能力等方面去考虑，细分形成数十个指标因子，覆盖基金全生命周期。其目的在与帮助投资者更好地了解投资对象的风险收益特征、业绩表现，方便投资者进行基金之间的比较和选择。'
					},
					advantage: {
						background: {
							imgPath: '',
							isLoading: false,
							imgLoading: false
						},
						describe: '1、投资决策依据：帮助投资者选择优秀基金，做出明智投资决策。|2、激励基金经理：促使基金经理努力提高基金表现，增加声誉和职业发展。'
					},
					productList: [{
							reportName: '基金投资项目估值',
							reportStage: '',
							reportType: '16',
							reportExample: ''
						}, {
							reportName: '政府出资基金绩效评价',
							reportStage: '5',
							reportType: '9',
							reportExample: ''
						},
						{
							reportName: '政府出资基金估值',
							reportStage: '5',
							reportType: '10',
							reportExample: ''
						}
					],

				},


			}
		},
		mounted() {
			this.isShow = true
			// this.getInfo(2, 6)
		},
		methods: {



		}


	}
</script>

<style scoped lang="less">
	.name {
		font-size: 20px;
		font-weight: bold;
		color: #282828;
		margin-bottom: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/deep/ .description {
		font-size: 14px;
		color: #282828;
		line-height: 22px;


		p {
			margin-bottom: 10px;
			display: flex;

			i {
				vertical-align: top;
			}

			span {
				width: calc(100% - 20px);
				margin-left: 3px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				display: inline-block;
			}
		}
	}

	.operate {
		display: flex;
		align-items: center;

		button,
		a {
			height: 30px;
			line-height: 30px;
			font-size: 14px;
			text-align: center;
			outline: none;
			cursor: pointer;
		}
	}

	.one_product {
		height: 272px;
		background: var(--mainColor);
		padding: 0 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		>div {
			width: 580px;
			height: 212px;
			border: 2px solid #FFFFFF;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		ul {
			li {
				width: 485px;

				.name,
				/deep/ .description {
					color: #fff;
				}

				.operate {
					button {
						width: 200px;
						background: #fff;
						border: 1px solid #fff;
						color: var(--mainColor);
					}

					a {
						width: 200px;
						background: var(--mainColor);
						border: 1px solid #fff;
						color: #fff;
					}

					button:hover {
						background: var(--mainColor);
						color: #fff;
					}

					a:hover {
						background: var(--complementaryColors);
					}

				}

				button,
				a {
					width: 245px;
					height: 36px;
					line-height: 36px;
				}

			}

		}

	}


	/deep/ .multipleProducts:not(.threeProducts) {
		>li:nth-child(odd) {
			margin-right: 20px;
		}

		>li {
			width: 590px;
			height: 308px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;

			img {
				width: 246px;
				height: 100%;
				object-fit: cover;
			}

			>div {
				width: 300px;
				height: 100%;
				position: relative;
				padding: 20px 0;
				margin-right: 20px;
			}

		}

		.operate {
			position: absolute;
			bottom: 20px;

			button,
			a {
				width: 140px;
			}

			button {
				margin-right: 10px;
			}
		}

	}

	/deep/ .multipleProducts {
		display: flex;
		flex-wrap: wrap;

		>li {
			position: relative;
			background-size: cover !important;
			box-shadow: 2px 2px 13px 0px rgba(6, 76, 156, 0.23);
			margin-bottom: 20px;
		}


		.description {
			i {
				color: var(--mainColor);
			}
		}

	}

	/deep/ .threeProducts {

		>li:nth-child(-n+2) {
			margin-right: 20px;
		}

		>li {
			width: 386px;
			height: 296px;
			padding: 30px 30px 0 30px;
		}

		.operate {
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			border-top: 1px solid #E0E0E0;

			button,
			a {
				width: 50%;
				height: 42px;
				line-height: 42px;
				background: transparent;
				color: var(--mainColor);
			}

			button {
				border-right: 1px solid #E0E0E0;
			}

			button:hover,
			a:hover {
				text-decoration: underline !important;
			}


		}


	}


	.evaluationIntroduction {
		width: 100%;
		height: 306px;
		background-size: cover !important;
		position: relative;

		>div {
			width: 1200px;
			height: 100%;
			display: flex;
			align-items: center;
			margin: 0 auto;

			p {
				width: 550px;
				font-size: 14px;
				line-height: 30px;
				color: #282828;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 7;
			}
		}
	}

	.preponderance {
		width: 1200px;
		height: 308px;
		display: flex;
		justify-content: space-between;
		margin: 0 auto 60px;

		>div:first-child {
			width: 681px;
			box-shadow: 2px 2px 13px 0px rgba(6, 76, 156, 0.23);
			border: 2px solid #fff;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		
		>div:last-child {
			width: 498px;
			height: 100%;
			background: var(--mainColor);
			color: #fff;
			padding: 36px;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			
			>ul {
			
				>li {
					width: 100%;
					font-size: 14px;
					color: #fff;
					line-height: 26px;
				}
			}
		}

		

	}
</style>